<template>
  <div class="ConflictReport">
    <box :title="$t('search')">
      <div class="pa-2">
        <daily-date-picker @getDate="search" />
      </div>
    </box>

    <box class="mt-2" :title="$t('functionalityList')">
      <div v-if="list.length > 0">
        <personel-conflict-list-web :list="list" class="hidden-sm-and-down" />
        <personel-conflict-list-mob :list="list" class="hidden-md-and-up" />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import PersonelConflictListMob from "../../components/personelOperationReport/PersonelConflictList/PersonelConflictListMob.vue";
import PersonelConflictListWeb from "../../components/personelOperationReport/PersonelConflictList/PersonelConflictListWeb.vue";
import Box from "../../components/widget/Box.vue";
import DailyDatePicker from "../../components/widget/DailyDatePicker.vue";
import ResultType from "../../model/ResultType";
export default {
  components: {
    DailyDatePicker,
    Box,
    PersonelConflictListWeb,
    PersonelConflictListMob,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    search(beginDate, endDate) {
      var perno = this.$store.state.auth.auth.username;
      var params = {
        perno: perno,
        begindate: beginDate,
        enddate: endDate,
      };
      this.$store.dispatch("GetPersonConflict", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data.Table;
        }
      });
    },
  },
};
</script>

<style>
</style>